module.exports = __webpack_public_path__ + "static/media/3DPPA14.5746a127.jpg";